
    import { Component, Prop, Vue } from 'nuxt-property-decorator';

    function isValidHTML(html) {
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(html, 'text/html');

        // Проверяем наличие ошибок парсинга
        const errorNode = parsedDocument.querySelector('parsererror');
        return !errorNode;
    }

    function formatHTML(html) {
        if (!isValidHTML(html)) {
            console.error('Invalid HTML detected, skipping formatting.');
            return html; // Возвращаем оригинальный HTML, если он невалидный
        }

        const tab = '\t'; // или используйте пробелы '    ' для отступов
        let formatted = '';
        let indentLevel = 0;

        // Регулярное выражение для разделения строки
        const elements = html
            .split(/(>)(<)/g)
            .filter(Boolean)
            .join('')
            .split(/(<[^>]+>)/g)
            .filter(Boolean);

        elements.forEach(element => {
            element = element.trim();

            if (element.length === 0) {
                return; // пропускаем пустые элементы
            }

            if (element.match(/^<\/\w/)) {
                // Закрывающий тег
                indentLevel--;
                formatted += `${tab.repeat(indentLevel)}${element}\n`;
            } else if (element.match(/^<\w/) && !element.match(/\/>$/)) {
                // Открывающий тег
                formatted += `${tab.repeat(indentLevel)}${element}\n`;
                indentLevel++;
            } else if (element.match(/^<\w/) && element.match(/\/>$/)) {
                // Самозакрывающийся тег
                formatted += `${tab.repeat(indentLevel)}${element}\n`;
            } else if (element.match(/^<\//)) {
                // Закрывающий тег без перехода строки
                indentLevel--;
                formatted += `${tab.repeat(indentLevel)}${element}\n`;
            } else {
                // Текст или содержимое тега
                formatted += `${tab.repeat(indentLevel)}${element}\n`;
            }
        });

        return formatted.trim();
    }

    function formatCSS(css) {
        const tab = '\t'; // or use spaces '    ' for indentation
        let formatted = '';
        let indentLevel = 0;

        // Remove extra spaces and normalize the formatting
        css = css
            .replace(/\s*{\s*/g, ' {')
            .replace(/\s*}\s*/g, '}')
            .replace(/\s*;\s*/g, ';')
            .replace(/\s*:\s*/g, ': ')
            .replace(/\s*,\s*/g, ', ')
            .replace(/\n/g, '')
            .replace(/\s\s+/g, ' ') // collapse multiple spaces
            .trim();

        // Split into individual lines
        const lines = css.split(/(?<=[{};])/);

        lines.forEach(line => {
            line = line.trim();

            if (line.endsWith('}')) {
                // Decrease indentation level but prevent it from going below 0
                indentLevel = Math.max(indentLevel - 1, 0);
                formatted += `${tab.repeat(indentLevel)}${line}\n`;
            } else if (line.endsWith('{')) {
                // Place the selector or block opening at the current indentation level
                formatted += `${tab.repeat(indentLevel)}${line}\n`;
                indentLevel++;
            } else if (line.endsWith(';')) {
                // CSS property line
                formatted += `${tab.repeat(indentLevel)}${line}\n`;
            } else {
                // Single line with no ending symbol (potentially a selector)
                formatted += `${tab.repeat(indentLevel)}${line}\n`;
            }
        });

        return formatted.trim();
    }

    @Component
    export default class OptionsFieldsCode extends Vue {
        @Prop() value;
        @Prop() option;

        get model() {
            return this.value;
        }

        set model(val) {
            this.$emit('input', val);
        }

        formatHTML() {
            this.$emit('input', formatHTML(this.value));
        }

        format() {
            this.$emit(
                'input',
                this.option.language === 'html'
                    ? formatHTML(this.value)
                    : formatCSS(this.value)
            );
        }
    }
